<template>
  <div class="dataContent">
    <div class="dataTitle">料肉比（FCR）分析<span class="dataTitleTips">（基于饲料BU全部数据实时生成）</span></div>
    <div>
      <div id="graph"></div>
      <div id="svgcontainer" class="svgcontainer"></div>
    </div>
    <!-- <div style="padding: 20px;">
      <h3 class="bold" >数据统计说明</h3>
      1、<span class="bold">单阶段数据</span>：如教槽、保育前期等，指实证中仅填写单一阶段的数据。若填写阶段超出1个，则不属于单阶段数据。<br />
      2、<span class="bold">全程数据</span>：指实证体重区间≥100kg，或填写全部7个实证阶段的数据<br />
      3、<span class="bold">其他</span>：指即不属于单阶段，又不属于全程的数据。<span class="red">该类数据正常纳入统计，暂不纳入分析</span><br />
      4、<span class="bold">异常数据</span>：指料肉比异常（{{lessThan}}0.5或{{greaterThan}}10 ）或造肉成本异常（{{lessThan}}1 或{{greaterThan}}20）的数据。<span class="red">该类数据正常纳入统计，暂不纳入分析</span>
    </div> -->
  </div>
</template>

<script>
// const Plotly = require('@/assets/js/plotly-2.2.0.min.js')
const Plotly = require('plotly.js-dist-min')
import api from '../api';
// let timepath = null
export default {
  components: {},
  props: [],
  data() {
    return {
      greaterThan: '>',
      lessThan: '<',
      nameLs: [],
      valLs: [],
      selfNames: [],
      selfValues: [],
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.getList()
  },
  methods: {
    async getList(){
      let res = await api.analysisWeightCost()
      let nameLs = [],valLs = [],selfNames = [],selfValues = []
      let {data=[]} = res || {}
      data.forEach(el => {
        el.valueList && el.valueList.forEach(item => {
          nameLs.push(el.labelName)
          valLs.push(item.value)
          if(item.self){
            selfNames.push(el.labelName)
            selfValues.push(item.value)
          }
        })
      })
      this.nameLs = nameLs
      this.valLs = valLs
      this.selfNames = selfNames
      this.selfValues = selfValues
      setTimeout(() => {
        this.initViolin()
      }, 0);
    },
    initViolin(){  //渲染violin图
      let nameLs = this.nameLs
      let valLs = this.valLs
      let rows = Array.from({length: nameLs.length},(e,i) => {
        return {
          EXPRESSION_VALUE: valLs[i],
          GROUP_NAME: nameLs[i],
          GROUP_SHORT: nameLs[i],
        }
      })
      let selfRows = Array.from({length: this.selfNames.length},(e,i) => {
        return {
          EXPRESSION_VALUE: this.selfValues[i],
          GROUP_NAME: this.selfNames[i],
          GROUP_SHORT: this.selfNames[i],
        }
      })
      function unpack(rows, key) {
        return rows.map(function(row) { return row[key]; });
      }
      let x = unpack(rows, 'GROUP_SHORT')
      let y = unpack(rows, 'EXPRESSION_VALUE')
      let data = [
        {
          type: 'violin',
          mode: 'violin',
          x,y,
          points: false,
          // hoverinfo: 'skip',// hover不显示数据信息；skip显示数据
          // box: {
          //   visible: true
          // },
          // line: {
          //   color: 'green',
          // },
          // fillcolor: 'cornflowerblue',
          opacity: 0.6,
          // meanline: {
          //   visible: true
          // },
          // showlegend: false,//图例
          name: '阶段',
          transforms: [
            {
              type: 'groupby',
              groups: unpack(rows, 'GROUP_SHORT'),
              // styles: [
              //   {target: '保育前期', value: {line: {color: 'red'}}},
              //   {target: '保育后期', value: {line: {color: 'green'}}},
              //   {target: '仔猪', value: {line: {color: 'blue'}}},
              // ],
            }
          ]
        },
        {
          x: unpack(selfRows, 'GROUP_SHORT'),
          y: unpack(selfRows, 'EXPRESSION_VALUE'),
          mode: 'markers',
          name: 'self',
        }
      ]
      let layout = {
        // title: "violin",
        displayModeBar:false,
        xaxis: {
          // "tickangle": 10,//倾斜角度
          // title: {
          //   text: '阶段'
          // },
        },
        yaxis: {
          zeroline: true,
          // title: {
          //   text: '重量'
          // },
        },
        height: 500,
        margin: { l: 50, b: 30, r: 50, t: 20 },
      }

      Plotly.newPlot('graph', data, layout, {displayModeBar:false,scrollZoom: false});
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>